<!---开始学习-->
<template>
    <div class="el-StartLearning">
        <el-row class="page_content">
            <h1 class="head_title_white">
                <el-button type="primary" @click="closePage">关 闭</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px; border-bottom: 1px dashed #ababab">
                <el-row>
                    <div class="learning_img">
                        <p v-if="leaningInfo.courseName == '-'" style="text-align: center; line-height: 200px">
                            <i class="el-icon-loading" style="margin: 0 auto"></i>
                        </p>
                        <img :src="leaningInfo.courseThumbnail || courseThumbnail" v-if="leaningInfo.courseName != '-'"
                            style="width: 100%; height: 100%" />
                    </div>
                    <h1>{{ courseName }}</h1>
                    <el-row style="
              float: left;
              width: 600px;
              border: 1px solid #e7e7e7;
              height: 160px;
              padding: 0px 20px;
              border-radius: 10px;
            ">
                        <h4>{{ courseName }}</h4>
                        <el-col :span="6" style="text-align: right; padding-right: 20px">学习时间：</el-col>
                        <el-col :span="10">
                            <el-progress :stroke-width="22" :show-text="false" :percentage="percentage"
                                color="#70b603"></el-progress>
                        </el-col>
                        <el-col :span="8" style="text-align: left; padding-left: 20px; color: #848585">
                            <!-- {{$returnMin(leaningInfo.learnedAllTime)}} -->
                            {{ ontime == -1 ? getOntime() : 0 }} /
                            {{ $returnMin(leaningInfo.courseVideoAllTime) }}（分钟）
                        </el-col>
                        <el-col :span="24" style="text-align: right; padding-top: 17px">
                            <el-button type="success" @click="startStudy"  v-if="leaningInfo.courseVideoAllTime > 0" >开始学习</el-button>
                            <el-button type="warning" @click="seeData_dzjc" v-if="leaningInfo.electronicTextbooksList != null && leaningInfo.electronicTextbooksList.length > 0">电子教材</el-button>
                            <el-button type="warning" @click="seeData" v-if="leaningInfo.teachingPlanCourseResourceList != null &&  leaningInfo.teachingPlanCourseResourceList.length > 0">查看资源</el-button>
                            <!-- <el-button type="info" @click="getLeaningLog">学习记录</el-button> -->
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
            <el-row class="record" v-if="dialogVisible">
                <h1>课件 {{ courseName }} 的详细记录</h1>
                <el-table :data="LeaningLog" border style="width: 100%">
                    <el-table-column prop="courseName" label="章节" header-align="center" width="400">
                        <template slot-scope="scope">
                            <template v-if="scope.row.courseType == 3">
                                <span style="margin-left: 25px;">{{ scope.row.courseName }}</span>
                            </template>
                            <template v-else="scope.row.courseType == 4">
                                <span style="margin-left: 50px;">{{ scope.row.courseName }}</span>
                            </template>
                            <template v-else>
                                {{ scope.row.courseName }}
                            </template>
                            <template
                                v-if="scope.row.tePlanCourseVideoList.length > 0 && Number(scope.row.tePlanCourseVideoList[0].courseVideoTime) <= Number(scope.row.tePlanCourseVideoList[0].tsTime)">
                                <span style="margin-left: 10px;">已学</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="courseName" label="时间" header-align="center" align="center" width="180">
                        <template slot-scope="scope">
                            <template v-if="!$isEmpty(scope.row.tePlanCourseVideoList[0])">
                                {{ $returnMin(getLogTime(scope.$index, scope.row.tePlanCourseVideoList), 2) }}
                                /
                                {{ $returnMin(scope.row.tePlanCourseVideoList[0].courseVideoTime, 2) }}
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" width="250" header-align="center" align="center" label="进度">
                        <template slot-scope="scope">
                            <template v-if="!$isEmpty(scope.row.tePlanCourseVideoList[0])">
                                <!--  -->
                                <el-progress :stroke-width="10"
                                    :percentage="Number((getLogTime(scope.$index, scope.row.tePlanCourseVideoList,1)/scope.row.tePlanCourseVideoList[0].courseVideoTime * 100).toFixed(0))"
                                    color="#70b603"></el-progress>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" width="200" header-align="center" align="center" label="操作">
                        <template slot-scope="scope">
                            <template v-if="!$isEmpty(scope.row.tePlanCourseVideoList[0])">
                                <template
                                    v-if="(getLogTime(scope.$index, scope.row.tePlanCourseVideoList,1)/scope.row.tePlanCourseVideoList[0].courseVideoTime * 100).toFixed(0) < 100">
                                    <el-link type="primary" @click="learnNow(scope.$index)">立即学习</el-link>
                                </template>
                                <template v-else>
                                    <el-link type="success" @click="learnNow(scope.$index)">重新学习</el-link>
                                </template>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name1" label="">
                    </el-table-column>
                </el-table>
            </el-row>
        </el-row>
        <resourceView v-if="showResource" :showResource="showResource" :tePlanCourseId="tePlanCourseId"
            @closeMsg="closeMsg"></resourceView>
        <resourceView v-if="showResource_dzjc" :showResource="showResource_dzjc" :tePlanCourseId="tePlanCourseId"
            showResourceType="3" @closeMsg="closeMsg"></resourceView>
    </div>
</template>
<script>
    import png from "@/images/course.png";
    import {
        getStorageKeyForRoleTag
    } from "../../common/ulit";
    import resourceView from "@/components/resourceView"; //资源
    export default {
        components: {
            resourceView
        },
        name: "StartLearning",
        data() {
            return {
                ontime: 0,
                timer: "",
                dialogImageUrl: "",
                dialogVisible: true,
                showResource: false,
                showResource_dzjc: false,
                courseName: this.$Base64.decode(this.$route.query.courseName), //课程名称
                tePlanCourseId: this.$route.query.tePlanCourseId,
                leaningInfo: {
                    courseName: "-",
                    courseThumbnail: "-",
                },
                teachingPlanCourseList: [],
                percentage: 0,
                LeaningLog: [], //学习记录
                courseThumbnail: png,
                courseInfoLog: {}, //课程播放记录
                courseTimeMap: {}, //课程的相应视频播放记录
            };
        },
        created() {
            localStorage.removeItem(getStorageKeyForRoleTag("time_"));
            if (this.$isEmpty(this.tePlanCourseId)) {
                this.$message({
                    message: "课程数据丢失，请返回上一页！",
                    type: "warning",
                });
            } else {
                this.getLeaning();

                //是否播放完成的标记
                if (
                    !this.$isEmpty(
                        localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId)
                    )
                ) {
                    this.courseInfoLog = JSON.parse(
                        localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId)
                    );
                    if (this.courseInfoLog == null || this.courseInfoLog == "") {
                        this.courseInfoLog = {};
                    }
                }
                //当前课程的播放时间记录
                if (
                    !this.$isEmpty(
                        localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId)
                    )
                ) {
                    this.courseTimeMap = JSON.parse(
                        localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId)
                    );
                    if (this.courseTimeMap == null || this.courseTimeMap == "") {
                        this.courseTimeMap = {};
                    }
                }

                let this_ = this;
                setTimeout(function() {
                    this_.getLeaningLog();
                }, 3000);
            }
        },
        methods: {
            handleLoad() {
                //用于重载人脸识别组件
                this.timer = new Date().getTime();
            },
            closePage() {
                window.location.href = "about:blank";
                window.close();
            },
            startStudy() {
                if (!this.$isEmpty(this.leaningInfo.courseUrl)) {
                    window.open(this.leaningInfo.courseUrl);
                } else {
                    this.$router.push({
                        name: "StudyAuthentication",
                        query: {
                            tePlanCourseId: this.tePlanCourseId,
                            courseName: this.courseName,
                        },
                    });
                }
            },
            seeData() { //查看资源
                this.showResource = true;
            },
            closeMsg() { //弹窗关闭回调
                this.showResource = false;
                this.showResource_dzjc = false;
            },
            seeData_dzjc() { //查看资源
                this.showResource_dzjc = true;
            },
            getLeaning() {
                //获取学习信息
                this.$store
                    .dispatch("user/getLeaning", {
                        tePlanCourseId: this.tePlanCourseId
                    })
                    .then((ret) => {
                        if (ret.code === 0 || ret.code === "0") {
                            this.leaningInfo = ret.data;
                            this.teachingPlanCourseList = ret.teachingPlanCourseList;
                            // this.LeaningLog = ret.teachingPlanCourseList;
                            if (
                                !this.$isEmpty(this.leaningInfo.courseVideoAllTime) &&
                                this.leaningInfo.courseVideoAllTime != 0
                            ) {
                                this.percentage = Number(this.$returnMin(this.leaningInfo.learnedAllTime) / this
                                    .$returnMin(this.leaningInfo.courseVideoAllTime)) * 100;
                            }
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: "warning",
                            });
                        }
                    });
            },
            getLeaningLog() {
                //获取学习记录
                this.dialogVisible = true;
                this.$store
                    .dispatch("user/getLeaningLog", {
                        tePlanCourseId: this.tePlanCourseId
                    })
                    .then((ret) => {
                        if (ret.code === 0 || ret.code === "0") {
                            this.LeaningLog = ret.data;
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: "warning",
                            });
                        }
                    });
            },
            getLogTime(i, tePlanCourseVideoList, tag) {
                //主要为了与视频播放页面同步显示记录
                let time = 0;
                for (let index = 0; index < tePlanCourseVideoList.length; index++) {
                    let serverTime = tePlanCourseVideoList[index].tsTime;
                    let endTime = tePlanCourseVideoList[index].courseVideoTime; //视频时长

                    if (this.courseInfoLog[i] == "OK") {
                        //如果存在播放完成的记录这直接返回结束时间
                        time = Number(endTime);
                    } else {
                        let localTime = this.courseTimeMap[i]; //从缓存获取本地播放记录时间
                        if (!this.$isEmpty(localTime)) {
                            localTime = Number(localTime) * 1000;
                        }
                        if (!this.$isEmpty(localTime) && !this.$isEmpty(serverTime)) {
                            //都不为空时就进入判断 取值（从后端拿，没有的，用后端的，比缓存时间大的，用后端，其他的用前端的，然后都以前端为准）
                            if (localTime < Number(serverTime)) {
                                time = Number(serverTime);
                            } else {
                                time = Number(localTime);
                            }
                        } else if (!this.$isEmpty(localTime) || !this.$isEmpty(serverTime)) {
                            if (this.$isEmpty(localTime)) {
                                time =
                                    Number(serverTime) >= Number(endTime) ?
                                    Number(endTime) :
                                    Number(serverTime);
                            } else if (this.$isEmpty(serverTime)) {
                                time = Number(localTime);
                            }
                        }
                    }
                }
                if (tag != 1) {
                    localStorage.setItem(
                        getStorageKeyForRoleTag("time_"),
                        Number(localStorage.getItem(getStorageKeyForRoleTag("time_"))) + Number(time)
                    );
                }

                if (i == this.LeaningLog.length - 1) {
                    this.ontime = -1;
                }
                return time;
            },
            getOntime() {
                return this.$returnMin(localStorage.getItem(getStorageKeyForRoleTag("time_")));
            },
            learnNow(index) {
                if (!this.$isEmpty(this.leaningInfo.courseUrl)) {
                    window.open(this.leaningInfo.courseUrl);
                } else {
                    localStorage.setItem(getStorageKeyForRoleTag("currentActive_") + this.tePlanCourseId, index);
                    this.$router.push({
                        name: "StudyAuthentication",
                        query: {
                            tePlanCourseId: this.tePlanCourseId,
                            courseName: this.courseName
                        },
                    });
                }
            }
        },
    };
</script>
<style lang="less">
    @import "../../styles/base.less";

    .el-StartLearning {
        .head_title_white {
            text-align: right;
            margin-bottom: 0;
            padding: 10px 30px;
        }

        .el-table th.el-table__cell,
        .el-table tr {
            // background-color: #f2f2f2;
        }

        .bg_ {
            height: 10px;
            background-color: @mainBg;
            margin: 0 -20px;
        }

        .learning_img {
            width: 400px;
            height: 220px;
            border: 1px solid rgb(238, 238, 238);
            float: left;
            margin-right: 20px;
        }

        .el-main {
            min-width: 1200px;
        }

        .record {
            height: calc(50vh - 20px);
            overflow: auto;
            // background-color: rgba(242, 242, 242, 1);
            margin-top: 20px;
            padding: 20px;
            margin-bottom: 20px;

            li {
                list-style-type: none;
                line-height: 30px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/StartLearning.vue